const rtfcConfig = {
  highlightsJson: "./data/rtfc/rtfc-highlights-tags-string-colors-.5-strip-ziegler-hue-sort.json",
  tagsColorsJson: "./data/rtfc/rtfc-tags-colors-.5-strip-ziegler-hue-sort.json",
  medleysJson: "./data/rtfc/rtfc-medleys.json",
  projectTitle: "Real Talk for Change Boston",
  projectDescription: "It was time for Boston’s historically underheard to have a voice. Leading up to the local elections in November 2021, Real Talk For Change introduced a new civic infrastructure to engage Boston residents in community-led constructive conversations. This city-wide effort was a collaboration between the MIT Center for Constructive Communication, Cortico, and a network of local community organizations."
/*   autoconnectHighlights: [], //5242881, 5244525, 3166734, 4112246, 5244581],
 */};

 const rtbostonConfig = {
  highlightsJson: "./data/rtboston/rtboston-highlights-tags-string-colors.json",
  tagsColorsJson: "./data/rtboston/rtboston-tags-colors.json",
  medleysJson: "./data/rtboston/rtboston-medleys.json",
  projectTitle: "realtalk@Boston",
  projectDescription: "realtalk@Boston is a collaboration between the MIT Center for Constructive Communication, Cortico, and a growing network of local community organizations in Boston. Together, we launched a new civic initiative designed to amplify the voices of Boston community members who are often underheard by current civic processes. We held 50 hours of small group conversations across 11 community organizations engaging 253 local participants."
/*   autoconnectHighlights: [], //5242881, 5244525, 3166734, 4112246, 5244581],
 */};
 
 const radiusConfig = {
  highlightsJson: "./data/radius/radius-highlights-tags-string-colors.json",
  tagsColorsJson: "./data/radius/radius-tags-colors.json",
  medleysJson: "./data/radius/radius-medleys.json",
  projectTitle: "Radius x realtalk@MIT: Ethics in Funding",
  projectDescription: "Radius and realtalk@MIT partnered to host a series of conversations with MIT students, staff, and faculty about their experiences with funding sources for their work or research which may not align with their moral or ethical values. MIT community members share the actions they take, and the uncertainty may they feel, when confronting these misalignments."
};

const config = radiusConfig;

export default config;
